import * as THREE from 'three';
import { NOISE_GLSL } from './glsl.js';

const DOME_R = 295;

// ===== SHIELD DOME VISUAL CONTROLS =====
const BASE_COLOR = new THREE.Color(0.91, 0.46, 0.16);    // warm orange (original)
const GLOW_COLOR = new THREE.Color(1.00, 0.8, 0.4);    // lighter orange
const GLOW_INTENSITY = 2.0;                              // multiplier for the glow contribution
// ========================================

const VERT = `
${NOISE_GLSL}
uniform float uTime;
uniform float uStage;
varying vec3 vPos;
varying vec3 vN;
varying float vGlow;
void main(){
  vec3 p=position;
  float n=snoise(p*.008+vec3(uTime*.12,uTime*.08,0.));
  p+=normalize(p)*(n*2.+uStage*3.);
  vPos=p; vN=normalize(normalMatrix*normal);
  float d=length(p.xz)/250.;
  vGlow=smoothstep(.8,.3,d)*(uStage*.15+.05);
  gl_Position=projectionMatrix*modelViewMatrix*vec4(p,1.);
}
`;
const FRAG = `
varying vec3 vPos;
varying vec3 vN;
varying float vGlow;

uniform vec3 uBaseColor;
uniform vec3 uGlowColor;
uniform float uGlowIntensity;

void main(){
  float fr=pow(1.-abs(dot(vN,vec3(0.,0.,1.))), 2.2);
  vec3 col = uBaseColor * 0.35;                          // base ambient
  col += uGlowColor * fr * 0.45;                         // fresnel rim
  col += uGlowColor * vGlow * uGlowIntensity;            // stage‑based glow
  gl_FragColor = vec4(col, fr * 0.25 + vGlow * 0.7);
}
`;

export class ShieldDome {
  constructor(scene) { this.scene = scene; this._mat = null; }

  init() {
    const geo = new THREE.SphereGeometry(DOME_R, 64, 32, 0, Math.PI*2, 0, Math.PI/2);
    geo.translate(0, -20, 0);
    this._mat = new THREE.ShaderMaterial({
      vertexShader: VERT,
      fragmentShader: FRAG,
      uniforms: {
        uTime: { value: 0 },
        uStage: { value: 0 },
        uBaseColor: { value: BASE_COLOR },
        uGlowColor: { value: GLOW_COLOR },
        uGlowIntensity: { value: GLOW_INTENSITY }
      },
      transparent: true,
      side: THREE.DoubleSide,
      depthWrite: false
    });
    this.scene.add(new THREE.Mesh(geo, this._mat));
  }

  update(time, smoothStage) {
    if (this._mat) {
      this._mat.uniforms.uTime.value = time;
      this._mat.uniforms.uStage.value = 0.0;
    }
  }
}